import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["question", "exitOptions", "buttons", "contactInfo"];

  declare readonly questionTarget: HTMLElement;
  declare readonly exitOptionsTarget: HTMLElement;
  declare readonly buttonsTarget: HTMLElement;
  declare readonly contactInfoTarget: HTMLElement;

  showExitOptions() {
    this.questionTarget.classList.add("hidden");
    this.buttonsTarget.classList.add("hidden");
    this.contactInfoTarget.classList.add("hidden");
    this.exitOptionsTarget.classList.remove("hidden");
  }

  showQuestion() {
    this.questionTarget.classList.remove("hidden");
    this.buttonsTarget.classList.remove("hidden");
    this.contactInfoTarget.classList.remove("hidden");
    this.exitOptionsTarget.classList.add("hidden");
  }
}
